import { render, staticRenderFns } from "./ListaCotacaoProdutos.vue?vue&type=template&id=1b011d74&"
import script from "./ListaCotacaoProdutos.vue?vue&type=script&lang=js&"
export * from "./ListaCotacaoProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
